import { Box, Stack, Typography } from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';

type SelectDateAndTimeFormProps = {
  setStartTimestamp: Dispatch<SetStateAction<number | null>>;
  setEndTimestamp: Dispatch<SetStateAction<number | null>>;
  setFormattedDate: Dispatch<SetStateAction<string>>;
};

const SelectDateAndTimeForm: FC<SelectDateAndTimeFormProps> = ({
  setStartTimestamp,
  setEndTimestamp,
  setFormattedDate,
}) => {
  const [date, setDate] = useState<Dayjs | null>(null);
  const [startTime, setStartTime] = useState<Dayjs | null>(null);
  const [endTime, setEndTime] = useState<Dayjs | null>(null);

  const getTimestamp = (time: Dayjs | null) =>
    time
      ?.set('year', date?.year()!)
      .set('month', date?.month()!)
      .set('date', date?.date()!)
      .valueOf()! / 1000 ?? null;

  const handleDateUpdate = (newDate: Dayjs | null) => {
    setDate(newDate);
    setFormattedDate(newDate?.format('YYYY-MM-DD') ?? '');
  };

  const handleUpdateStartTime = (newStartTime: Dayjs | null) => {
    const newEndTime = dayjs(newStartTime).add(30, 'minutes') ?? null;

    setStartTime(newStartTime);
    setEndTime(newEndTime);

    setStartTimestamp(getTimestamp(newStartTime));
    setEndTimestamp(getTimestamp(newEndTime));
  };

  const handleUpdateEndTime = (newEndTime: Dayjs | null) => {
    setEndTime(newEndTime);
    setEndTimestamp(getTimestamp(newEndTime));
  };

  return (
    <Stack spacing={2}>
      <Stack spacing={2}>
        <Box>
          <Typography>Date:</Typography>
          <DatePicker
            disablePast
            value={date}
            onChange={handleDateUpdate}
            format="MM/DD/YYYY"
            sx={{
              width: '100%',
            }}
          />
        </Box>
        <Stack sx={{ width: '100%', }} direction="row" spacing={1}>
          <Box sx={{ width: '100%', }}>
            <Typography>Start time:</Typography>
            <TimePicker
              value={startTime}
              onChange={handleUpdateStartTime}
              // maxTime={endTime!}
              sx={{
                width: '100%',

              }}
            />
          </Box>
          <Box sx={{ width: '100%', }}>
            <Typography>End time:</Typography>
            <TimePicker
              value={endTime}
              onChange={handleUpdateEndTime}
              minTime={startTime!}
              sx={{
                width: '100%',
              }}
            />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SelectDateAndTimeForm;
